/**
 * GSD degree programmes, keyed by the abbreviation stored on a profile affiliation.
 *
 * Mirrors the Ruby implementation's degree_program component translations, which
 * render an abbreviation followed by the full name in brackets.
 */
export const DEGREE_PROGRAM_NAMES = {
  DDes: 'Doctor of Design Studies',
  'MArch I AP': 'Master in Architecture I AP',
  'MArch I': 'Master in Architecture I',
  'MArch II': 'Master in Architecture II',
  MDes: 'Master in Design Studies',
  'MDes AP': 'Master in Design Studies AP',
  'MLA I AP': 'Master in Landscape Architecture I AP',
  'MLA I': 'Master in Landscape Architecture I',
  'MLA II': 'Master in Landscape Architecture II',
  MUP: 'Master in Urban Planning',
  MAUD: 'Master of Architecture in Urban Design',
  MLAUD: 'Master of Landscape Architecture in Urban Design',
  MDE: 'Master in Design Engineering',
  PhD: 'PhD',
};

/**
 * "MArch I (Master in Architecture I)", falling back to the bare abbreviation when the
 * programme is not one we have a name for.
 */
export function formatDegreeProgram(abbr) {
  if (!abbr) return '';

  const name = DEGREE_PROGRAM_NAMES[abbr];

  return name ? `${abbr} (${name})` : abbr;
}
